import React from "react";
import { FaWhatsapp } from "react-icons/fa";

// Add this style block for bounce animation if you want to keep it
const bounceStyle = `
@keyframes bounceY {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}
.bounceY {
  animation: bounceY 1.5s infinite;
}
`;

export const Whatsapp = () => {
  return (
    <>
      <style>{bounceStyle}</style>
      <div className="position-fixed bottom-0 end-0 m-4" style={{zIndex: 20}}>
        <a
          href="https://wa.me/971565858882"
          target="_blank"
          rel="noopener noreferrer"
          className="position-relative d-flex align-items-center bounceY text-white p-2 rounded-circle shadow hover-bg-light transition"
          style={{textDecoration: 'none', background: 'oklch(72.3% 0.219 149.579)'}}
        >
          {/* Notification Badge */}
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{fontSize: '8px', width: '16px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0}}>
            1
          </span>
          <FaWhatsapp style={{width: '32px', height: '32px', color: 'white'}} />
        </a>
      </div>
    </>
  );
};
